var NotificationSubject = {
  MERCURIAL_DELETE_OR_UPDATE: 0,
  PRODUCT_DELETED: 1,
  PRODUCT_ON_CART_UPDATED: 2,
};

module.exports = NotificationSubject;
